import { UserDto } from 'apis/config/swagger-types';
import _join from 'lodash/join';

export const listUserRoles = (roles: UserDto['roles']) => {
  const userRoles: string[] = [];
  roles.map((role) => userRoles.push(role?.name));

  return _join(userRoles, ', ');
};
